const leaveBalanceReducer = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default leaveBalanceReducer;